












































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';
import Select from '@/components/Select.vue';
import Toggle from '@/components/Toggle.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';

import PermissionTree from '@/components/PermissionTree/PermissionTree.vue';
import api from '@/libs/api';
import {
  PermissionApiResponse, Group, GroupApiResponse, GroupPermissionApiReponse, UserRoleApiResponse,
  UsersApiResponse, User,
} from '@/libs/api.interfaces';
// eslint-disable-next-line import/no-cycle
import hasPermission from '@/libs/permission';
import { ToastType } from '@/store/toast';
import { showToast } from '@/libs/toast';
import { AxiosError } from 'axios';

import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Header from '@/components/Table/Header.vue';
import Row from '@/components/Table/Row.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    FormInput,
    Select,
    PermissionTree,
    Toggle,
    Button,
    Loader,
    ValidationObserver,
    StatusIndicator,
    Pagination,
    Row,
    TableBody,
    Cell,
    Header,
    Checkbox,
  },
  methods: {
    hasPermission,
  },
})
export default class UserRoleEditor extends Vue {
  type = '';
  isEdit = false;
  detailPermissionProcessed = false;
  name = '';
  group: Group | null = null;
  loading = false;
  loadingPermission = false;
  loadingSubmit = false;
  loadingUser = false;
  status = false;
  groupPermission: string[] = [];
  groupDetailPermission: string[] = [];
  basePermission: PermissionItem[] = [];
  permissions: PermissionItem[] = [];
  groups: Group[] = [];
  users: User[] = [];
  listDataUser: any[] = [];
  selectedUser: { [rowId: string]: any } = {};
  pageUser = 1;
  totalPageUser = 1;
  fromUser = 0;
  toUser = 0;
  totalItemUser = 0;
  showTableUser = false;
  errors = {
    group: '',
  }

  hasPermission!: (val: string | string[]) => boolean;

  async mounted() {
    this.type = this.$route.params.type;
    if (this.type !== 'internal' && this.type !== 'external') this.$router.back();
    this.isEdit = this.$route.name === 'UserRoleEdit';

    await this.getPermissions();
    await this.getGroups();
    await this.getUsers();

    if (this.isEdit) {
      this.getRoleDetail();
    }
  }

  get typeTitle() {
    return this.type ? `${this.type[0].toUpperCase()}${this.type.substring(1)}` : '';
  }

  @Watch('group')
  onGroupChange() {
    if (this.group === null) return;
    this.getGroupPermission(this.group.id);
  }

  @Watch('pageUser')
  onPageUserChange() {
    this.getUsers();
  }

  private async submit() {
    if (this.group === null) {
      this.errors.group = 'Please select group first';
      return;
    }

    const listSelectedUser: string[] = Object.keys(this.selectedUser) || [];

    const permissions = this.flattenPermission(this.permissions as PermissionItemCheck[]);

    try {
      this.loadingSubmit = true;
      /* eslint-disable @typescript-eslint/camelcase */
      await api({
        method: this.isEdit ? 'PUT' : 'POST',
        url: `/user-role${this.isEdit ? `/${this.$route.params.id}` : ''}`,
        data: {
          user_group_id: this.group.id,
          user_role: this.name,
          user_permissions: this.isEdit ? undefined : permissions,
          permission_id: this.isEdit ? permissions : undefined,
          is_internal: this.type === 'internal',
          status: this.status,
          user_id_permissions: listSelectedUser,
        },
      });
      /* eslint-enable @typescript-eslint/camelcase */
      this.loadingSubmit = false;
      this.$router.back();
      showToast(ToastType.SUCCESS, 'Congratulations', `User role has been ${this.isEdit ? 'updated' : 'created'}`);
    } catch (err) {
      this.loadingSubmit = false;
      console.error(err);
      const error = err as AxiosError;
      showToast(ToastType.FAILED, `Error ${error.response?.status}`,
        `Failed to ${this.isEdit ? 'updated' : 'create'} the role`);
    }
  }

  private async getRoleDetail() {
    try {
      const { data } = await api.get<UserRoleApiResponse>(`/user-role/${this.$route.params.id}/permissions`);
      const group = this.groups.find((e) => e.id === data.data.items.user_role.user_group.id);
      this.status = data.data.items.user_role.status === 'ACTIVE';
      this.group = group || null;
      this.name = data.data.items.user_role.role;

      this.groupDetailPermission = data.data.items.permission;
      const user = JSON.parse(localStorage.getItem('USER') || '{}');
      // if (user.user.user_role.level >= data.data.items.user_role.level) {
      //   // this.showTableUser = false;
      // } else {
      //   // this.showTableUser = true;
      // }
    } catch (err) {
      console.error(err);
      const error = err as AxiosError;
      showToast(ToastType.FAILED, `Error ${error.response?.status}`, 'Failed to get user role detail');
    }
  }

  private async getPermissions() {
    this.loadingPermission = true;
    try {
      const { data } = await api.get<PermissionApiResponse>('/permissions', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          is_internal: this.$route.params.type === 'internal',
        },
      });
      const permissions = data.data;
      if (permissions) {
        this.basePermission = permissions;
        this.permissions = permissions;
      }
      this.loadingPermission = false;
    } catch (err) {
      console.error(err);
      const error = err as AxiosError;
      showToast(ToastType.FAILED, `Error ${error.response?.status}`, 'Failed to get permission list');
      this.loadingPermission = false;
    }
  }

  private async getGroups() {
    try {
      this.loading = true;
      const { data } = await api.get<GroupApiResponse>('/user-groups');
      this.groups = data.data.items.filter((e) => e.is_internal === (this.type === 'internal' ? 1 : 0));
      this.loading = false;
    } catch (err) {
      console.error(err);
      const error = err as AxiosError;
      showToast(ToastType.FAILED, `Error ${error.response?.status}`, 'Failed to get group list');
    }
  }

  private async getGroupPermission(id: number) {
    this.loadingPermission = true;
    try {
      this.permissions = [];

      const { data } = await api.get<GroupPermissionApiReponse>(`/user-group/${id}/permissions`);
      this.groupPermission = data.data.permission;
      this.permissions = this.checkPermission(this.basePermission as PermissionItemCheck[], 0);

      if (!this.detailPermissionProcessed && this.isEdit) {
        this.permissions = this.checkPermissionView(this.permissions as PermissionItemCheck[]);
        this.detailPermissionProcessed = true;
      }

      this.loadingPermission = false;
    } catch (err) {
      console.error(err);
      showToast(ToastType.FAILED, 'Error', 'Failed to get group permissions');
      this.loadingPermission = false;
    }
  }

  private checkPermissionView(child: PermissionItemCheck[]) {
    const newPermissionsValue = [...child];
    return newPermissionsValue.map((p) => {
      const perm = { ...p };
      if (perm.child) {
        perm.child = this.checkPermissionView(perm.child as PermissionItemCheck[]);
      }

      if (this.groupDetailPermission.includes(perm.value)) {
        perm.checkValue = 'CHECKED';
      } else {
        perm.checkValue = 'UNCHECKED';
      }

      return perm;
    }, [] as PermissionItemCheck[]);
  }

  private checkPermission(child: PermissionItemCheck[], level: number) {
    const newPermissionsValue = [...child];
    return newPermissionsValue.reduce((prev, p) => {
      const perm = { ...p };
      if (perm.child) {
        perm.child = this.checkPermission(perm.child as PermissionItemCheck[], level + 1);
      }

      if (this.groupPermission.includes(perm.value)) {
        perm.checkValue = 'CHECKED';
      }

      if ((perm.checkValue !== undefined || level !== 1)
        && ((perm.child !== undefined && perm.child.length !== 0) || level !== 0)) {
        prev.push(perm);
      }

      return prev;
    }, [] as PermissionItemCheck[]);
  }

  private flattenPermission(child: PermissionItemCheck[]) {
    return child.reduce((prev: string[], p) => {
      if (p.child) {
        prev.push(...this.flattenPermission(p.child as PermissionItemCheck[]));
      }

      if (p.checkValue === 'CHECKED' || p.checkValue === 'PARTIAL') {
        prev.push(p.value);
      }

      return prev;
    }, []);
  }

  async getUsers() {
    this.loadingUser = true;
    try {
      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.get<UsersApiResponse>('/users', {
        params: {
          page: this.pageUser,
          role_id: [this.$route.params.id],
        },
      });
      this.listDataUser = data.data;
      this.fromUser = data.from;
      this.toUser = data.to;
      this.totalItemUser = data.total;
      this.totalPageUser = Math.ceil(data.total / data.per_page);
      this.loadingUser = false;
      this.showTableUser = true;
    } catch (err) {
      console.error(err);
      this.loadingUser = false;
    }
  }

  selectRow(itemData: any) {
    if (this.isSelected(itemData.id)) {
      this.$delete(this.selectedUser, itemData.id);
    } else {
      this.$set(this.selectedUser, itemData.id, itemData);
    }

    this.$emit('select-change', Object.keys(this.selectedUser).length);
  }

  isSelected(rowId: any) {
    return this.selectedUser[rowId] !== undefined;
  }

  get isAllUserChecked() {
    return this.listDataUser.every((e) => this.selectedUser[e.id] !== undefined);
    // return true;
  }

  checkAll(checked: boolean) {
    if (checked) {
      this.listDataUser.forEach((e) => {
        this.$set(this.selectedUser, e.id, e);
      });
    } else {
      this.listDataUser.forEach((e) => {
        this.$delete(this.selectedUser, e.id);
      });
    }
    this.$emit('select-change', Object.keys(this.selectedUser).length);
  }
}
